import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import InfoBanner from 'shared-components/banners/InfoBanner';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';

const SurveillanceFields = ({ surveillanceToggleFieldValue, intl }) => {
  const translationMessages = defineMessages({
    yes: {
      id: 'hosting.surveillance_fields.yes_label',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'hosting.surveillance_fields.no_label',
      defaultMessage: 'No'
    }
  });
  const infoBannerBody = (<div>
    <FormattedMessage
      id="hosting.surveillance_fields.recording_devices_policy"
      defaultMessage="Recording devices in bathrooms or dressing rooms are prohibited by the {link}."
      values={{
        link: (<a href="/legal/terms" target="_blank">
          <FormattedMessage id="hosting.surveillance_fields.recording_devices_policy_link_text" defaultMessage="Peerspace Services Agreement"/></a>)
      }}
    />
  </div>);

  return (
    <div>
      <div className="flex column relative">
        <h2 className=""><FormattedMessage id="hosting.surveillance_fields.recording_devices_heading" defaultMessage="Security cameras and recording devices"/></h2>
        <div className="flex flex-start column-sm space-between text-large">
          <span className='margin-md-right'>
            <FormattedMessage id="hosting.surveillance_fields.recording_devices_availability" defaultMessage="Does the space have security cameras or recording devices?"/>
          </span>
          <div className="toggle-field">
            <Field
              name='has_surveillance'
              className="flex"
              component={ToggleField}
              attributes={{
                'data-testing-id': 'has-surveillance-toggle',
                name: 'has_surveillance'
              }}
              firstOption={
                {
                  id: 'has-surveillance-true',
                  value: 'true',
                  label: intl.formatMessage(translationMessages.yes)
                }}
              secondOption={
                {
                  id: 'has-surveillance-false',
                  value: 'false',
                  label: intl.formatMessage(translationMessages.no)
                }}
              errorPositionedClassName="error-positioned no-bottom-margin"
            />
          </div>
        </div>
      </div>
      {
        'true' === surveillanceToggleFieldValue
        && (
          <div>
            <p className="text-gray-dark margin-lg-top"><FormattedMessage id="hosting.surveillance_fields.recording_devices_description_label" defaultMessage="Describe any device that records video, audio, or still images. Specify where each device is in your space and if they’ll be on or off."/></p>
            <Field
              name="surveillance_description"
              attributes={{
                'data-testing-id': 'surveillance-description'
              }}
              component={TextAreaField}
              placeholder={intl.formatMessage({ id: 'hosting.surveillance_fields.recording_devices_description_placeholder', defaultMessage: 'Add description' })}
            />
            <div className="flex end">
              <p className="text-gray-600 margin-md-top"><FormattedMessage id="hosting.surveillance_fields.recording_devices_description_min_character_count" defaultMessage="Minimum 50 characters"/></p>
            </div>
            <InfoBanner icon="info-black" body={infoBannerBody} classNames="flex margin-xl-bottom margin-md-top"/>
          </div>
        )
      }
    </div>
  );
};

SurveillanceFields.propTypes = {
  surveillanceToggleFieldValue: PropTypes.string,
  intl: intlShape
};

export default injectIntl(SurveillanceFields);
